import React, { useState } from 'react';
import { FaCheckCircle, FaFileAlt, FaUserGraduate, FaCalendarAlt } from 'react-icons/fa';
import emailjs from '@emailjs/browser';

const SERVICE_ID  = 'service_d4rl7zn';
const TEMPLATE_ID = 'template_8z8pqbl';
const PUBLIC_KEY  = 'U_1wRqsGOXp3l5Txi';

const Admissions = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name:  formData.fullName,
          from_email: formData.email,
          phone:      formData.phone,
        },
        PUBLIC_KEY
      );

      setIsSubmitted(true);
      setFormData({ fullName: '', email: '', phone: '' });
    } catch (err) {
      console.error('EmailJS error:', err);
      setError('There was an error submitting your application. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const admissionSteps = [
    { icon: <FaFileAlt />,       title: 'Step 1: Fill Application',  description: 'Complete the online application form with accurate details.' },
    { icon: <FaUserGraduate />,  title: 'Step 2: Submit Documents',  description: 'Upload required documents including mark sheets and certificates.' },
    { icon: <FaCheckCircle />,   title: 'Step 3: Application Review',description: 'Our admission team will review your application within 3-5 business days.' },
    { icon: <FaCalendarAlt />,   title: 'Step 4: Confirmation',      description: 'Receive admission confirmation and complete enrollment process.' }
  ];

  return (
    <div>
      <section className="hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <h2>Admissions</h2>
          <p>Start Your Journey with Fast Track College of Business, Healthcare and Technology</p>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="section-title">Admission Process</h2>
          <div className="features-grid">
            {admissionSteps.map((step, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{step.icon}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="contact" style={{ background: 'var(--light-bg)' }}>
        <div className="container">
          <h2 className="section-title">Apply Now</h2>
          <p style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto 2rem', color: 'var(--light-text)' }}>
            Fill out the application form below to begin your admission process. Our team will contact you
            within 3-5 business days with the next steps.
          </p>

          <div style={{ maxWidth: '900px', margin: '0 auto', background: 'white', padding: '2.5rem', borderRadius: '10px', boxShadow: '0 3px 10px rgba(0,0,0,0.1)' }}>
            {isSubmitted ? (
              <div style={{ textAlign: 'center', padding: '3rem 2rem' }}>
                <div style={{ fontSize: '4rem', color: '#28a745', marginBottom: '1rem' }}>✓</div>
                <h3 style={{ color: 'var(--primary-color)', marginBottom: '1rem', fontSize: '1.8rem' }}>Application Submitted Successfully!</h3>
                <p style={{ color: 'var(--light-text)', marginBottom: '2rem', fontSize: '1.1rem' }}>
                  Thank you for applying to Fast Track College of Business, Healthcare and Technology. We have received your application and will contact you within 3-5 business days.
                </p>
                <button className="btn btn-primary" onClick={() => setIsSubmitted(false)}>
                  Submit Another Application
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="admission-form">
                {error && (
                  <div style={{ padding: '1rem', marginBottom: '1.5rem', background: '#f8d7da', color: '#721c24', borderRadius: '5px', border: '1px solid #f5c6cb' }}>
                    {error}
                  </div>
                )}

                <div className="form-group">
                  <label htmlFor="fullName">Full Name *</label>
                  <input type="text" id="fullName" name="fullName" value={formData.fullName}
                    onChange={handleChange} required placeholder="Enter your full name" />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input type="email" id="email" name="email" value={formData.email}
                    onChange={handleChange} required placeholder="your.email@example.com" />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Telephone Number *</label>
                  <input type="tel" id="phone" name="phone" value={formData.phone}
                    onChange={handleChange} required placeholder="+1 (234) 567-8900" />
                </div>

                <button type="submit" className="btn btn-primary"
                  style={{ width: '100%', marginTop: '1rem', padding: '1rem', fontSize: '1.1rem' }}
                  disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting Application...' : 'Submit Application'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      <section className="about">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="section-title">Need Help?</h2>
          <p style={{ maxWidth: '600px', margin: '0 auto 1.5rem', color: 'var(--light-text)' }}>
            If you have any questions about the admission process or need assistance with your application,
            please don't hesitate to contact us.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="tel:+14377846664" className="btn btn-primary">Call Us</a>
            <a href="mailto:janushan335@gmail.com" className="btn btn-secondary">Email Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Admissions;
